import React from 'react';
import GridContainer from "./Grid/GridContainer.jsx";
import GridItem from "./Grid/GridItem.jsx";
import { withStyles, Button, Typography,withWidth } from '@material-ui/core';
import SubjectIcon from '@material-ui/icons/Subject';
const styles = theme => ({
    primaryBtn: { color: theme.palette.text.textPrimaryColor, backgroundColor: theme.palette.primary.main, border: `1px solid${theme.palette.border.primaryBorder}`,
  borderRadius: "50px", margin: "8px 0", textAlign: "right", padding: "7px 20px", textTransform: "uppercase", '&:hover': { backgroundColor: theme.palette.hoverPrimaryColor.main,
    color: theme.palette.text.hoverTextPrimaryColor, border: `1px solid ${theme.palette.border.hoverPrimaryBorder}`, } },
    pad0: { padding: 0 },
    icnWrap: { background: "#e3ecef", borderRadius: "50%", lineHeight: 0, display: "inline-flex", fontSize: "12px !important", fontWeight: 700, margin: "0 5px", },
    btnIcon: { fontSize: "14px !important", color: "#8a9fa5" },
    gridAlign: { alignItems: "center", margin: "20px 0 15px" },
    countPatients: { fontSize: "14px !important", color: "#06303f" },
    patientTit: { fontWeight: 500, fontSize: "40px !important", color: "#06303f" },

});

const DashboardTitle = (props) => {
const { classes} =props;
  return(
    <>     <GridContainer style={{ alignItems: "center", marginTop:30 }}>
                        <GridItem md={12}>
                          <GridContainer className={classes.gridAlign}>
                          <GridItem md={3} className={classes.pad0}>
                          <Typography variant="h4" className={classes.patientTit}>{props.titlename} &nbsp;&nbsp;&nbsp;</Typography></GridItem>
                                <GridItem md={3} className={classes.pad0}>
                      <span className={classes.icnWrap}><SubjectIcon className={classes.btnIcon}/></span>
                      <span className={classes.countPatients}>{props.count+" "+props.titlename}</span>
                      </GridItem>
                      {props.titlename==="Article"?<>
                      <GridItem md={2} className={classes.pad0}> <Button className={classes.primaryBtn}  onClick={props.button1}
                        classes={{ label: classes.viewButtonLabel }}> Category List </Button></GridItem>
                      <GridItem md={2} className={classes.pad0}>  <Button className={classes.primaryBtn}  onClick={props.button2}
                      classes={{ label: classes.viewButtonLabel }}> ADD NEW VIDEO</Button></GridItem></>:
            <><GridItem md={2} className={classes.pad0}></GridItem><GridItem md={2} className={classes.pad0}></GridItem></>}
                      <GridItem md={2} className={classes.pad0}><Button className={classes.primaryBtn} onClick={props.button3}
                        classes={{ label: classes.viewButtonLabel }}> ADD NEW {props.titlename}</Button></GridItem>
                      </GridContainer>
                        </GridItem>
                    </GridContainer></>
   );
  };


export default withWidth()((withStyles(styles)(DashboardTitle)));